import React, { useEffect, useState } from 'react';
import './css/slider.css';
import B1 from '../assets/gallery/activities/indoractivities.jpg';
import B2 from '../assets/gallery/activities/C7.jpg';
import B3 from '../assets/gallery/activities/outdoractivities.jpg';


const Slider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visible, setVisible] = useState(true);

    const nextSlide = () => {
        setVisible(false); // Hide the current slide
        setTimeout(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === slides.length - 1 ? 0 : prevIndex + 1
            );
            setVisible(true); // Show the next slide
        }, 500); // Wait for the transition duration before changing the index
    };

    const prevSlide = () => {
        setVisible(false); // Hide the current slide
        setTimeout(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === 0 ? slides.length - 1 : prevIndex - 1
            );
            setVisible(true); // Show the previous slide
        }, 500); // Wait for the transition duration before changing the index
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 10000); // Change every 10 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="slider">
            <div className="slider-content" style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>
                <img src={slides[currentIndex].image} alt={slides[currentIndex].title} className="slider-image" />
                <div className="slider-text">
                    <h3>{slides[currentIndex].title}</h3>
                    <p>{slides[currentIndex].description}</p>
                </div>
            </div>
            <div className="slider-arrows">
                <button onClick={prevSlide} className="slider-arrow left-arrow">❮</button>
                <button onClick={nextSlide} className="slider-arrow right-arrow">❯</button>
            </div>
        </div>
    );

};

const slides = [
    {
        id: 1,
        image: B1, // Replace with actual image URLs
        title: 'Indoor Activities',
        description:'Unwind and have fun with our array of indoor activities, designed for all ages. Whether you are looking to engage in a friendly game, relax with a book, or enjoy some leisure time with family and friends, our indoor facilities provide the perfect setting. From board games to reading lounges, there is something for everyone.',
    },
    {
        id: 2,
        image: B2,
        title: 'Tranquil Oasis Pool Experience',
        description:'Dive into relaxation at our stunning pool, surrounded by lush greenery and serene views. Perfect for a refreshing swim or unwinding by the water, it’s your ultimate escape in nature’s embrace.'
    },
    {
        id: 3,
        image: B3,
        title: 'Outdoor Activities',
        description:'Experience the great outdoors with our variety of outdoor activities. Immerse yourself in the beauty of Kithul Kanda as you partake in exhilarating experiences like bird watching, nature walks, or a refreshing dip in our infinity pool. Our outdoor activities are tailored to enhance your connection with the natural world and provide endless fun.'
    },
    // Add more slides here if needed
];

<div class="component"> <Slider /></div> 

export default Slider;